import type { PassengerType } from '@models/landing/master-data/master-data.model';

/**
 * Delay duration in milliseconds for passenger navigation transitions
 */
export const PASSENGER_NAVIGATION_DELAY = 1500;

/** Normalizes a passenger-type string to the DS/contact `PassengerType` union. */
export const toPassengerType = (value: string | undefined): PassengerType => {
  if (value === 'Child' || value === 'Infant') {
    return value;
  }
  return 'Adult';
};

/**
 * Creates a debounced passenger selection handler with a delay
 * @param setPassenger - The state setter function for passenger selection
 * @param delay - Delay in milliseconds (defaults to PASSENGER_NAVIGATION_DELAY)
 * @returns A debounced selection handler
 */
export const createDelayedPassengerSelector = <T>(
  setPassenger: (value: T) => void,
  delay: number = PASSENGER_NAVIGATION_DELAY,
): ((value: T) => void) => {
  let timeoutId: ReturnType<typeof setTimeout> | null = null;

  return (value: T): void => {
    if (timeoutId !== null) {
      clearTimeout(timeoutId);
    }

    timeoutId = setTimeout(() => {
      setPassenger(value);
      timeoutId = null;
    }, delay);
  };
};
